import { useProfileHome } from "@/hooks/useProfileHome";
import type { NoTaskAvailableState } from "@/types";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Sends the labeler back to a jobs-table tab after a task page found nothing
 * to serve, carrying `NoTaskAvailableState` so the table explains the bounce.
 * `replace` keeps Back from landing on the page that just bounced them.
 */
export const useBounceToJobs = () => {
  const navigate = useNavigate();
  const { jobsPath } = useProfileHome();
  return useCallback(
    (
      tab: string,
      jobId: string,
      reason: NoTaskAvailableState["noTaskReason"] = "unavailable",
    ) => {
      const state: NoTaskAvailableState = {
        noTaskAvailableJobId: jobId,
        noTaskReason: reason,
      };
      navigate(`${jobsPath}?tab=${tab}`, { replace: true, state });
    },
    [navigate, jobsPath],
  );
};
